import { ILanguageResources, ITranslationModule } from '../interfaces';
import { interpolate } from '../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'V6FrameConfig';

  // Login messages
  public static readonly menuHistory = `${Id.prefix}.menu.history`;
  public static readonly menuFavourites = `${Id.prefix}.menu.Favourites`;
  public static readonly menuCategories = `${Id.prefix}.menu.Categories`;
  public static readonly menuItems = `${Id.prefix}.menu.Items`;

  // New label entries
  public static readonly labelCode = `${Id.prefix}.label.Code`;
  public static readonly labelDescription = `${Id.prefix}.label.Description`;
  public static readonly buttonCancel = `${Id.prefix}.button.Cancel`;
  // Glossary
  public static readonly labelResource = `${Id.prefix}.label.resource`;
  public static readonly resourcePickerTitle = `${Id.prefix}.resource.PickerTitle`;
  public static readonly pickTitle = `${Id.prefix}.pick.Title`;
  public static readonly labelItem = `${Id.prefix}.label.Item`;

  // Entries for each %%value%%
  public static readonly labelResourceAssembly = `${Id.prefix}.label.resource.Assembly`;
  public static readonly labelResourceComponent = `${Id.prefix}.label.resource.Component`;
  public static readonly labelResourceExtrusion = `${Id.prefix}.label.resource.Extrusion`;
  public static readonly labelResourceFill = `${Id.prefix}.label.resource.Fill`;
  public static readonly labelResourceFrame = `${Id.prefix}.label.resource.Frame`;
  public static readonly labelResourceAttachmentBag = `${Id.prefix}.label.resource.AttachmentBag`;
  public static readonly labelResourceIgu = `${Id.prefix}.label.resource.Igu`;
  public static readonly labelResourceGasket = `${Id.prefix}.label.resource.Gasket`;
  public static readonly labelFranchisee = `${Id.prefix}.label.Franchisee`;
  public static readonly buttonAddResource = `${Id.prefix}.button.AddResource`;
  public static readonly labelInitializingResource = `${Id.prefix}.label.InitializingResource`;
  public static readonly configuringFrame = `${Id.prefix}.configuring.Frame`;
  public static readonly labelLoading = `${Id.prefix}.label.Loading`;
  public static readonly titleResourceConfiguration = `${Id.prefix}.title.ResourceConfiguration`;
  public static readonly labelResourceFinish = `${Id.prefix}.label.resource.Finish`;
  public static readonly labelItemNumberLocation = `${Id.prefix}.label.ItemNumberLocation`;
  public static readonly labelAttribute = `${Id.prefix}.label.Attribute`;
  public static readonly labelCurrentValue = `${Id.prefix}.label.CurrentValue`;
  public static readonly labelReplacementValue = `${Id.prefix}.label.ReplacementValue`;
  public static readonly labelNotProcessed = `${Id.prefix}.label.NotProcessed`;
  public static readonly labelUpdating = `${Id.prefix}.label.Updating`;
  public static readonly labelSaving = `${Id.prefix}.label.Saving`;
  public static readonly labelSaved = `${Id.prefix}.label.Saved`;
  public static readonly labelError = `${Id.prefix}.label.Error`;
  public static readonly labelProcessing = `${Id.prefix}.label.Processing`;
  public static readonly labelClose = `${Id.prefix}.label.Close`;
  public static readonly labelProcessingComplete = `${Id.prefix}.label.ProcessingComplete`;
  public static readonly labelItemPosition = `${Id.prefix}.label.ItemPosition`;
  public static readonly titleApplyAttributeChangesToFrame = `${Id.prefix}.title.ApplyAttributeChangesToFrame`;
  public static readonly confirmCancelUpdates = `${Id.prefix}.confirm.CancelUpdates`;
  public static readonly labelCancellingOperations = `${Id.prefix}.label.CancellingOperations`;
  public static readonly labelPleaseWaitWhileProcessesCleanUp = `${Id.prefix}.label.PleaseWaitWhileProcessesCleanUp`;
  public static readonly labelAll = `${Id.prefix}.label.All`;
  public static readonly labelTitle = `${Id.prefix}.label.Title`;
  public static readonly allFramesConsistent = `${Id.prefix}.label.AllFramesConsistent`;
  public static readonly updateInconsistentFrames = `${Id.prefix}.label.UpdateInconsistentFrames`;
  public static readonly labelApply = `${Id.prefix}.label.Apply`;
  public static readonly labelProcessingResource = `${Id.prefix}.label.ProcessingResource`;
  public static readonly labelStatus = `${Id.prefix}.label.Status`;
  public static readonly allFramesProcessed = `${Id.prefix}.label.AllFramesProcessed`;
  public static readonly completedFrames = `${Id.prefix}.label.CompletedFrames`;

  public static readonly v6ServiceUnavailable = `${Id.prefix}.label.V6ServiceUnavailable`;
  public static readonly tryAgain = `${Id.prefix}.label.TryAgain`;
  public static readonly loading = `${Id.prefix}.label.Loading`;
  public static readonly frameType = `${Id.prefix}.label.FrameType`;
  public static readonly templateValue = `${Id.prefix}.label.TemplateValue`;
  public static readonly filterWillResetMarkedItems = `${Id.prefix}.label.FilterWillResetMarkedItems`;
  public static readonly changeAttributesForExisting = `${Id.prefix}.label.ChangeAttributesForExisting`;
  public static readonly changeDefaultsForNew = `${Id.prefix}.label.ChangeDefaultsForNew`;
  public static readonly noteGlobalAttributes = `${Id.prefix}.label.NoteGlobalAttributes`;
  public static readonly globalFrameAttributes = `${Id.prefix}.label.GlobalFrameAttributes`;
  public static readonly labelNewAttributeUnknownValue = `${Id.prefix}.label.NewAttributeUnknownValue`;
  public static readonly labelProperties = `${Id.prefix}.label.Properties`;
  public static readonly getQuoteIGUName = `${Id.prefix}.label.QuoteIGUName`;
  public static readonly labelResourceIguPlural = `${Id.prefix}.label.ResourceIguPlural`;
  public static readonly labelUpdate = `${Id.prefix}.label.Update`;
  public static readonly labelCancel = `${Id.prefix}.label.Cancel`;
  public static readonly titleUpdateQuoteDefaults = `${Id.prefix}.title.UpdateQuoteDefaults`;
  public static readonly labelSupplierNote = `${Id.prefix}.label.SupplierNote`;
  public static readonly labelFrameIssues = `${Id.prefix}.label.FrameIssues`;
  public static readonly labelValidationIssues = `${Id.prefix}.label.ValidationIssues`;
  public static readonly labelDimensions = `${Id.prefix}.label.Dimensions`;
  public static readonly labelZoomIn = `${Id.prefix}.label.ZoomIn`;
  public static readonly labelZoomOut = `${Id.prefix}.label.ZoomOut`;
  public static readonly labelFrameInformation = `${Id.prefix}.label.FrameInformation`;
  public static readonly labelFrameNavigation = `${Id.prefix}.label.FrameNavigation`;
  public static readonly labelContentRefreshing = `${Id.prefix}.label.ContentRefreshing`;
  public static readonly labelFrameConfiguration = `${Id.prefix}.label.FrameConfiguration`;
  public static readonly labelIguConfiguration = `${Id.prefix}.label.IguConfiguration`;
  public static readonly labelDimensionTooltip = `${Id.prefix}.label.DimensionTooltip`;
  public static readonly labelFetching = `${Id.prefix}.label.Fetching`;
  public static readonly labelRun = `${Id.prefix}.label.Run`;
  public static readonly labelPickQuoteIguBelow = `${Id.prefix}.label.PickQuoteIguBelow`;

  // VRML viewer related strings
  public static readonly vrmlViewerTitle = `${Id.prefix}.vrmlViewerTitle`;
  public static readonly vrmlViewerClose = `${Id.prefix}.vrmlViewerClose`;
  public static readonly vrmlViewerModels = `${Id.prefix}.vrmlViewerModels`;
  public static readonly vrmlViewerNoModel = `${Id.prefix}.vrmlViewerNoModel`;
  public static readonly otherGroupDescription = `${Id.prefix}.otherGroupDescription`;
  public static readonly invalidQuoteIguCode = `${Id.prefix}.invalidQuoteIguCode`;
  public static readonly labelFilter = `${Id.prefix}.label.Filter`;
  public static readonly placeHolderFilter = `${Id.prefix}.placeHolderFilter`; // Placeholder for filter input

  public static readonly tableHeaderDescription = `${Id.prefix}.tableHeader.Description`;
  public static readonly tableHeaderGroupDescription = `${Id.prefix}.tableHeader.GroupDescription`;
  public static readonly tableHeaderColor = `${Id.prefix}.tableHeader.Color`;
  public static readonly attributeTemplatesMenu = `${Id.prefix}.attributeTemplates.Menu`;
  public static readonly labelSelectAttributeTemplate = `${Id.prefix}.label.SelectAttributeTemplate`;
  public static readonly showAnnotationsMenu = `${Id.prefix}.showAnnotationsMenu`;
  public static readonly labelNoAttributeTemplatesSelected = `${Id.prefix}labelNoAttributeTemplatesSelected`;
  public static readonly attributeTemplateName = `${Id.prefix}attributeTemplateName`;
  public static readonly titleCreateAttributeTemplate = `${Id.prefix}titleCreateAttributeTemplate`;
  public static readonly messageAttributeTemplateAlreadyExists = `${Id.prefix}messageAttributeTemplateAlreadyExists`;
  public static readonly messageAttributeTemplateDeleted = `${Id.prefix}.message.AttributeTemplateDeleted`;
  public static readonly attributeTemplatesApplicatorMenu = `${Id.prefix}.attributeTemplatesApplicatorMenu`;
  public static readonly groupNameConfiguration = `${Id.prefix}groupNameConfiguration`;

  // Template menu button captions - renaming to be more specific
  public static readonly buttonAttributeTemplateAdd = `${Id.prefix}.button.AttributeTemplate.Add`;
  public static readonly buttonAttributeTemplateUpdate = `${Id.prefix}.button.AttributeTemplate.Update`;
  public static readonly buttonAttributeTemplateReset = `${Id.prefix}.button.AttributeTemplate.Reset`;
  public static readonly buttonAttributeTemplateDelete = `${Id.prefix}.button.AttributeTemplate.Delete`;
  public static readonly buttonAttributeTemplateView = `${Id.prefix}.button.AttributeTemplate.View`;
  public static readonly buttonAttributeTemplateHide = `${Id.prefix}.button.AttributeTemplate.Hide`;
  public static readonly buttonAttributeTemplateApply = `${Id.prefix}.button.AttributeTemplate.Apply`;
  public static readonly buttonAttributeTemplateShowValues = `${Id.prefix}.button.AttributeTemplate.ShowValues`;
  // Template messages
  public static readonly messageAttributeTemplateUpdated = `${Id.prefix}.message.AttributeTemplateUpdated`;

  public static readonly attributeTemplateApplied = `${Id.prefix}.message.AttributeTemplateApplied`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangV6 {
  static showAnnotationsMenu(): unknown {
    return interpolate(Id.showAnnotationsMenu);
  }
  static labelSelectAttributeTemplate(): string {
    return interpolate(Id.labelSelectAttributeTemplate);
  }
  static otherGroupDescription(): string {
    return interpolate(Id.otherGroupDescription);
  }
  static labelNoAttributeTemplatesSelected(productType: string): string {
    return interpolate(Id.labelNoAttributeTemplatesSelected, { productType });
  }
  static labelAttributeTemplateName(): string {
    return interpolate(Id.attributeTemplateName);
  }
  static titleCreateAttributeTemplate(productType: string): string {
    return interpolate(Id.titleCreateAttributeTemplate, { productType });
  }
  static messageAttributeTemplateAlreadyExists(templateName: string, frameType?: string): string {
    return interpolate(Id.messageAttributeTemplateAlreadyExists, { templateName, frameType: frameType ?? '' });
  }
  static messageAttributeTemplateUpdated(templateName: string, frameType?: string): string {
    return interpolate(Id.messageAttributeTemplateUpdated, { templateName, frameType: frameType ?? '' });
  }
  static messageAttributeTemplateDeleted(templateName: string, frameType?: string): string {
    return interpolate(Id.messageAttributeTemplateDeleted, { templateName, frameType: frameType ?? '' });
  }
  static attributeTemplateApplied(templateName: string, frameType?: string, attributeCount: number = 0): string {
    return interpolate(Id.attributeTemplateApplied, {
      templateName,
      frameType: frameType ?? '',
      attributeCount: attributeCount.toString()
    });
  }

  private constructor() {
    //do not create instances
  }

  public static attributeTemplatesMenu(): string {
    return interpolate(Id.attributeTemplatesMenu);
  }
  public static placeHolderFilter(): string {
    return interpolate(Id.placeHolderFilter);
  }

  public static menuHistory(): string {
    return interpolate(Id.menuHistory);
  }

  public static labelFilter(): string {
    return interpolate(Id.labelFilter);
  }

  public static menuFavourites(): string {
    return interpolate(Id.menuFavourites);
  }

  public static menuCategories(): string {
    return interpolate(Id.menuCategories);
  }

  public static invalidQuoteIguCode(code: string): string {
    return interpolate(Id.invalidQuoteIguCode, { code });
  }

  public static menuItems(): string {
    return interpolate(Id.menuItems);
  }

  public static labelCode(): string {
    return interpolate(Id.labelCode);
  }

  public static labelDescription(): string {
    return interpolate(Id.labelDescription);
  }

  public static buttonCancel(): string {
    return interpolate(Id.buttonCancel);
  }

  public static labelResource(): string {
    return interpolate(Id.labelResource);
  }

  public static resourcePickerTitle(resourceName: string): string {
    return interpolate(Id.resourcePickerTitle, { resourceName });
  }

  public static pickTitle(title: string): string {
    return interpolate(Id.pickTitle, { title });
  }

  public static labelItem(): string {
    return interpolate(Id.labelItem);
  }

  public static labelResourceAssembly(): string {
    return interpolate(Id.labelResourceAssembly);
  }

  public static labelResourceComponent(): string {
    return interpolate(Id.labelResourceComponent);
  }

  public static labelResourceExtrusion(): string {
    return interpolate(Id.labelResourceExtrusion);
  }

  public static labelResourceFill(): string {
    return interpolate(Id.labelResourceFill);
  }

  public static labelResourceFrame(): string {
    return interpolate(Id.labelResourceFrame);
  }

  public static labelResourceAttachmentBag(): string {
    return interpolate(Id.labelResourceAttachmentBag);
  }

  public static labelResourceIgu(): string {
    return interpolate(Id.labelResourceIgu);
  }

  public static labelResourceGasket(): string {
    return interpolate(Id.labelResourceGasket);
  }

  public static labelFranchisee(): string {
    return interpolate(Id.labelFranchisee);
  }

  public static buttonAddResource(resourceName: string): string {
    return interpolate(Id.buttonAddResource, { resourceName });
  }

  public static labelInitializingResource(resourceName: string): string {
    return interpolate(Id.labelInitializingResource, { resourceName });
  }

  public static configuringFrame(): string {
    return interpolate(Id.configuringFrame);
  }

  public static labelLoading(): string {
    return interpolate(Id.labelLoading);
  }

  public static titleResourceConfiguration(resourceName: string): string {
    return interpolate(Id.titleResourceConfiguration, { resourceName });
  }

  public static labelResourceFinish(): string {
    return interpolate(Id.labelResourceFinish);
  }

  public static labelItemNumberLocation(): string {
    return interpolate(Id.labelItemNumberLocation);
  }

  public static labelAttribute(): string {
    return interpolate(Id.labelAttribute);
  }

  public static labelCurrentValue(): string {
    return interpolate(Id.labelCurrentValue);
  }

  public static labelReplacementValue(): string {
    return interpolate(Id.labelReplacementValue);
  }

  public static labelNotProcessed(): string {
    return interpolate(Id.labelNotProcessed);
  }

  public static labelUpdating(): string {
    return interpolate(Id.labelUpdating);
  }

  public static labelSaving(): string {
    return interpolate(Id.labelSaving);
  }

  public static labelSaved(): string {
    return interpolate(Id.labelSaved);
  }

  public static labelError(): string {
    return interpolate(Id.labelError);
  }

  public static labelProcessing(): string {
    return interpolate(Id.labelProcessing);
  }

  public static labelClose(): string {
    return interpolate(Id.labelClose);
  }

  public static labelProcessingComplete(): string {
    return interpolate(Id.labelProcessingComplete);
  }

  public static labelItemPosition(position: number | string): string {
    return interpolate(Id.labelItemPosition, { position });
  }

  public static titleApplyAttributeChangesToFrame(): string {
    return interpolate(Id.titleApplyAttributeChangesToFrame);
  }

  public static confirmCancelUpdates(): string {
    return interpolate(Id.confirmCancelUpdates);
  }

  public static labelCancellingOperations(): string {
    return interpolate(Id.labelCancellingOperations);
  }

  public static labelPleaseWaitWhileProcessesCleanUp(): string {
    return interpolate(Id.labelPleaseWaitWhileProcessesCleanUp);
  }

  public static labelAll(): string {
    return interpolate(Id.labelAll);
  }

  public static labelTitle(): string {
    return interpolate(Id.labelTitle);
  }

  public static allFramesConsistent(): string {
    return interpolate(Id.allFramesConsistent);
  }

  public static updateInconsistentFrames(): string {
    return interpolate(Id.updateInconsistentFrames);
  }

  public static labelApply(): string {
    return interpolate(Id.labelApply);
  }

  public static labelProcessingResource(resourceName: string): string {
    return interpolate(Id.labelProcessingResource, { resourceName });
  }

  public static labelStatus(): string {
    return interpolate(Id.labelStatus);
  }

  public static allFramesProcessed(): string {
    return interpolate(Id.allFramesProcessed);
  }

  public static completedFrames(): string {
    return interpolate(Id.completedFrames);
  }

  public static v6ServiceUnavailable(): string {
    return interpolate(Id.v6ServiceUnavailable);
  }

  public static tryAgain(): string {
    return interpolate(Id.tryAgain);
  }

  public static loading(): string {
    return interpolate(Id.loading);
  }

  public static frameType(): string {
    return interpolate(Id.frameType);
  }

  public static TemplateValue(name?: string): string {
    return interpolate(Id.templateValue, { name });
  }

  public static filterWillResetMarkedItems(): string {
    return interpolate(Id.filterWillResetMarkedItems);
  }

  public static changeAttributesForExisting(): string {
    return interpolate(Id.changeAttributesForExisting);
  }

  public static changeDefaultsForNew(): string {
    return interpolate(Id.changeDefaultsForNew);
  }

  public static noteGlobalAttributes(): string {
    return interpolate(Id.noteGlobalAttributes);
  }

  public static globalFrameAttributes(): string {
    return interpolate(Id.globalFrameAttributes);
  }

  public static labelNewAttributeUnknownValue(): string {
    return interpolate(Id.labelNewAttributeUnknownValue);
  }

  public static labelProperties(): string {
    return interpolate(Id.labelProperties);
  }

  public static getQuoteIGUName(code: string, counterStr: string): string {
    return interpolate(Id.getQuoteIGUName, { code, counterStr });
  }

  public static labelResourceIguPlural(): string {
    return interpolate(Id.labelResourceIguPlural);
  }

  public static labelUpdate(): string {
    return interpolate(Id.labelUpdate);
  }

  public static labelCancel(): string {
    return interpolate(Id.labelCancel);
  }

  public static titleUpdateQuoteDefaults(): string {
    return interpolate(Id.titleUpdateQuoteDefaults);
  }

  public static labelSupplierNote(): string {
    return interpolate(Id.labelSupplierNote);
  }

  public static labelFrameIssues(): string {
    return interpolate(Id.labelFrameIssues);
  }

  public static labelValidationIssues(): string {
    return interpolate(Id.labelValidationIssues);
  }

  public static labelDimensions(): string {
    return interpolate(Id.labelDimensions);
  }

  public static labelZoomIn(): string {
    return interpolate(Id.labelZoomIn);
  }

  public static labelZoomOut(): string {
    return interpolate(Id.labelZoomOut);
  }

  public static labelFrameInformation(): string {
    return interpolate(Id.labelFrameInformation);
  }

  public static labelFrameNavigation(): string {
    return interpolate(Id.labelFrameNavigation);
  }

  public static labelContentRefreshing(): string {
    return interpolate(Id.labelContentRefreshing);
  }

  public static labelFrameConfiguration(): string {
    return interpolate(Id.labelFrameConfiguration);
  }

  public static labelIguConfiguration(): string {
    return interpolate(Id.labelIguConfiguration);
  }

  public static labelDimensionTooltip(): string {
    return interpolate(Id.labelDimensionTooltip);
  }

  public static labelFetching(): string {
    return interpolate(Id.labelFetching);
  }

  public static labelRun(): string {
    return interpolate(Id.labelRun);
  }

  public static labelPickQuoteIguBelow(): string {
    return interpolate(Id.labelPickQuoteIguBelow);
  }

  public static tableHeaderDescription(): string {
    return interpolate(Id.tableHeaderDescription);
  }

  public static tableHeaderGroupDescription(): string {
    return interpolate(Id.tableHeaderGroupDescription);
  }

  public static tableHeaderColor(): string {
    return interpolate(Id.tableHeaderColor);
  }

  public static attributeTemplatesApplicatorMenu(): string {
    return interpolate(Id.attributeTemplatesApplicatorMenu);
  }

  public static groupNameConfiguration(): string {
    return interpolate(Id.groupNameConfiguration);
  }

  // Template menu button methods - updated names
  public static buttonAttributeTemplateAdd(): string {
    return interpolate(Id.buttonAttributeTemplateAdd);
  }

  public static buttonAttributeTemplateReset(): string {
    return interpolate(Id.buttonAttributeTemplateReset);
  }
  public static buttonAttributeTemplateUpdate(): string {
    return interpolate(Id.buttonAttributeTemplateUpdate);
  }

  public static buttonAttributeTemplateDelete(): string {
    return interpolate(Id.buttonAttributeTemplateDelete);
  }

  public static buttonAttributeTemplateView(): string {
    return interpolate(Id.buttonAttributeTemplateView);
  }

  public static buttonAttributeTemplateHide(): string {
    return interpolate(Id.buttonAttributeTemplateHide);
  }

  public static buttonAttributeTemplateApply(): string {
    return interpolate(Id.buttonAttributeTemplateApply);
  }

  public static buttonAttributeTemplateShowValues(): string {
    return interpolate(Id.buttonAttributeTemplateShowValues);
  }

  // VRML Viewer related methods
  public static vrmlViewerTitle(): string {
    return interpolate(Id.vrmlViewerTitle);
  }

  public static vrmlViewerClose(): string {
    return interpolate(Id.vrmlViewerClose);
  }

  public static vrmlViewerModels(): string {
    return interpolate(Id.vrmlViewerModels);
  }

  public static vrmlViewerNoModel(): string {
    return interpolate(Id.vrmlViewerNoModel);
  }
}

export class V6FrameConfigModule implements ITranslationModule {
  registerItems(register: ILanguageResources): void {
    register.add(Id.menuHistory, 'History', 'Menu label for history');
    register.add(Id.menuFavourites, 'Favourites', 'Menu label for favourites');
    register.add(Id.menuCategories, 'Categories', 'Menu label for categories');
    register.add(Id.menuItems, 'Items', 'Menu label for items');
    register.add(Id.labelCode, 'Code', 'Label for code');
    register.add(Id.labelDescription, 'Description', 'Label for description');
    register.add(Id.buttonCancel, 'Cancel', 'Button label for cancel');
    register.add(Id.labelResource, `{{glossary 'resource'}}`, 'The term for a resource');
    register.add(Id.resourcePickerTitle, '{{resourceName}} Picker', 'Title for resource picker');
    register.add(Id.pickTitle, 'Pick {{title}}', 'Title for generic pick dialog');
    register.add(Id.labelItem, 'Item', 'Label for item');
    register.add(Id.labelResourceAssembly, `{{glossary 'assembly'}}`, 'The term for assembly');
    register.add(Id.labelResourceComponent, `{{glossary 'component'}}`, 'The term for component');
    register.add(Id.labelResourceExtrusion, `{{glossary 'extrusion'}}`, 'The term for extrusion');
    register.add(Id.labelResourceFill, `{{glossary 'fill'}}`, 'The term for fill');
    register.add(Id.labelResourceFrame, `{{glossary 'frame'}}`, 'The term for frame');
    register.add(Id.labelResourceAttachmentBag, `{{glossary 'attachment-bag'}}`, 'The term for attachment bag');
    register.add(Id.labelResourceIgu, `{{glossary 'igu'}}`, 'The term for igu');
    register.add(Id.labelResourceGasket, `{{glossary 'gasket'}}`, 'The term for gasket');
    register.add(Id.labelFranchisee, `{{glossary 'franchisee'}}`, 'The term for franchisee');
    register.add(Id.buttonAddResource, 'Add {{resourceName}}', 'Button label for adding a resource');
    register.add(Id.labelInitializingResource, 'Initializing {{resourceName}}', 'Label for initializing a resource');
    register.add(
      Id.configuringFrame,
      "Please wait while we configure the {{glossary 'frame'}}",
      'Message shown while configuring a frame'
    );
    register.add(Id.labelLoading, 'Loading', 'Label for loading state');
    register.add(Id.titleResourceConfiguration, '{{resourceName}} Configuration', 'Title for resource configuration');
    register.add(Id.labelResourceFinish, `{{glossary 'finish'}}`, 'The term for finish');
    register.add(Id.labelItemNumberLocation, 'Item # / Location', 'Table column: Item number and location');
    register.add(Id.labelAttribute, 'Attribute', 'Table column: Attribute');
    register.add(Id.labelCurrentValue, 'Current Value', 'Table column: Current value');
    register.add(Id.labelReplacementValue, 'Replacement Value', 'Table column: Replacement value');
    register.add(Id.labelNotProcessed, 'Not Processed', 'Badge: Not Processed');
    register.add(Id.labelUpdating, 'Updating', 'Badge: Updating');
    register.add(Id.labelSaving, 'Saving', 'Badge: Saving');
    register.add(Id.labelSaved, 'Saved', 'Badge: Saved');
    register.add(Id.labelError, 'Error', 'Badge: Error');
    register.add(Id.labelProcessing, 'Processing', 'Badge: Processing');
    register.add(Id.labelClose, 'Close', 'Label for close button');
    register.add(Id.labelProcessingComplete, 'Processing Complete', 'Label for processing complete');
    register.add(Id.labelItemPosition, '#{{position}}', 'Label for item position');
    register.add(
      Id.titleApplyAttributeChangesToFrame,
      "Apply Attribute Changes to {{glossary 'frame'}}",
      'Title for apply attribute changes to frame dialog'
    );
    register.add(
      Id.confirmCancelUpdates,
      'All updates may not have completed. Do you want to cancel update?',
      'Confirmation message for cancelling updates'
    );
    register.add(Id.labelCancellingOperations, 'Cancelling Operations', 'Label for cancelling operations');
    register.add(
      Id.labelPleaseWaitWhileProcessesCleanUp,
      'Please wait while the processes clean up',
      'Label for waiting during cleanup'
    );
    register.add(Id.labelAll, 'All', 'Label for all items');
    register.add(Id.labelTitle, 'Title', 'Label for title');
    register.add(
      Id.allFramesConsistent,
      "All {{glossary 'frame'}} are consistent with current settings",
      'Message for all frames consistent'
    );
    register.add(
      Id.updateInconsistentFrames,
      "Update inconsistent {{glossary 'frame'}}",
      'Title for update inconsistent frames'
    );
    register.add(Id.labelApply, 'Apply', 'Label for apply button');
    register.add(Id.labelProcessingResource, 'Processing {{resourceName}}', 'Label for processing a resource');
    register.add(Id.labelStatus, 'Status', 'Label for status');
    register.add(Id.allFramesProcessed, "All {{glossary 'frame'}} Processed", 'Label for all frames processed');
    register.add(Id.completedFrames, "Completed {{glossary 'frame'}}", 'Label for completed frames');

    register.add(Id.v6ServiceUnavailable, 'V6 Service is Unavailable', 'Message for V6 service unavailable');
    register.add(Id.tryAgain, 'Try Again', 'Button label for try again');
    register.add(Id.loading, 'Loading...', 'Label for loading');
    register.add(Id.frameType, "{{glossary 'frame'}} Type", 'Label for frame type');
    register.add(Id.templateValue, '{{name}} Template Value', 'Label for showing a template attribute value');
    register.add(Id.filterWillResetMarkedItems, 'Changing filter will reset marked items', 'Tooltip for filter reset');
    register.add(
      Id.changeAttributesForExisting,
      "To change attributes for existing {{glossary 'frame:plural'}} edit and click the 'Apply Changes' button.",
      'Instruction for changing attributes for existing frames'
    );
    register.add(
      Id.changeDefaultsForNew,
      "To change defaults for new {{glossary 'frame'}} edit the options below. To apply to existing {{glossary 'frame'}} edit then click the 'Apply Changes' button.",
      'Instruction for changing defaults for new frames'
    );
    register.add(
      Id.noteGlobalAttributes,
      "Please note that changes to Global Attributes must be applied on change, or the {{glossary 'frame'}} not matching will require validation to update",
      'Note for global attributes'
    );
    register.add(
      Id.globalFrameAttributes,
      "Global {{glossary 'frame'}} Attributes",
      'Header for global frame attributes'
    );
    register.add(
      Id.labelNewAttributeUnknownValue,
      'New Attribute (Unknown Value)',
      'Label for new attribute with unknown value'
    );
    register.add(Id.labelProperties, 'Properties', 'Label for properties section');
    register.add(Id.getQuoteIGUName, "{{glossary 'quote-igu'}}-{{code}}{{counterStr}}", 'Generated IGU name');
    register.add(Id.labelResourceIguPlural, "{{glossary 'quote-igu:plural'}}", 'Plural label for IGU resources');
    register.add(Id.labelUpdate, 'Update', 'Label for update button');
    register.add(Id.labelCancel, 'Cancel', 'Label for cancel button');
    register.add(
      Id.titleUpdateQuoteDefaults,
      "Update {{glossary 'quote'}} Defaults",
      'Title for update quote defaults modal'
    );
    register.add(Id.labelSupplierNote, "{{glossary 'supplier'}} note", 'Label for supplier note');
    register.add(Id.labelFrameIssues, "{{glossary 'frame'}} Issues", 'Label for frame issues');
    register.add(Id.labelValidationIssues, 'Validation Issues', 'Label for validation issues');
    register.add(Id.labelDimensions, 'Dimensions', 'Label for dimensions');
    register.add(Id.labelZoomIn, 'Zoom-in', 'Label for zoom-in');
    register.add(Id.labelZoomOut, 'Zoom-out', 'Label for zoom-out');
    register.add(Id.labelFrameInformation, "{{glossary 'frame'}} information", 'Label for frame information');
    register.add(Id.labelFrameNavigation, 'Frame Navigation', 'Label for frame navigation');
    register.add(Id.labelContentRefreshing, 'Your content is refreshing', 'Label for content refreshing');
    register.add(Id.labelFrameConfiguration, "{{glossary 'frame'}} Configuration", 'Label for frame configuration');
    register.add(Id.labelIguConfiguration, "{{glossary 'igu'}} Configuration", 'Label for IGU configuration');
    register.add(
      Id.labelDimensionTooltip,
      `The unlocked icon indicates that you can edit the dimension.

The ghosted icon indicates that you cannot edit the dimension here
  - this is because surrounding dimensions are locked and preventing changes
  - you can unlock the surrounding dimensions to allow changes, or edit dimensions in the outermost %%frame%%.

The locked (solid blue) icon indicates that you have locked this dimension.

Editing the dimension will automatically lock it. To unlock, click the lock icon.`,
      'Tooltip for dimension attribute'
    );
    register.add(Id.labelFetching, 'Fetching...', 'Label for fetching state');
    register.add(Id.labelRun, 'Run', 'Label for run button');
    register.add(
      Id.labelPickQuoteIguBelow,
      "Pick {{glossary 'quote-igu:plural'}} below', 'Label for picking quote IGU below"
    );
    register.add(
      Id.otherGroupDescription,
      'Other',
      'Description for "other" group in V6 configuration, a group that had no name'
    );
    register.add(
      Id.invalidQuoteIguCode,
      'Invalid Code \'{{code}}\'. Codes can only contain "A-Z._/#", information will not be saved until modified',
      'Error message for invalid quote IGU code'
    );
    register.add(Id.labelFilter, 'Filter', 'Label for filter input');
    register.add(Id.placeHolderFilter, 'Text Search', 'Placeholder text for filter search input');
    register.add(Id.tableHeaderDescription, 'Description', 'Table header: Description');
    register.add(Id.tableHeaderGroupDescription, 'Group Description', 'Table header: Group Description');
    register.add(Id.tableHeaderColor, 'Color', 'Table header: Color');
    register.add(Id.attributeTemplatesMenu, 'Edit Attribute Templates', 'Menu for attribute templates');
    register.add(
      Id.attributeTemplatesApplicatorMenu,
      'Use Attribute Templates',
      'Menu for attribute templates applicator'
    );
    register.add(
      Id.labelSelectAttributeTemplate,
      'Select Attribute Template',
      'Label for selecting attribute template'
    );
    register.add(Id.showAnnotationsMenu, 'Show Annotations As List', 'Menu for showing annotations');
    register.add(
      Id.labelNoAttributeTemplatesSelected,
      'No attributes have been selected for the template for {{productType}}',
      'Message shown when trying to create a template without selecting attributes'
    );
    register.add(
      Id.attributeTemplateName,
      'Attribute Template Name',
      'Title for dialog to get a name for an attribute template'
    );
    register.add(
      Id.titleCreateAttributeTemplate,
      'Create Attribute Template for {{productType}}',
      'Title for dialog when creating a new attribute template'
    );
    register.add(
      Id.messageAttributeTemplateAlreadyExists,
      'A template with the name "{{templateName}}" for {{frameType}} already exists',
      'Message shown when trying to create a template with a name that already exists'
    );
    register.add(Id.groupNameConfiguration, 'Configuration', 'Group name for frame configuration attributes');

    // Template menu button registrations - updated to be more specific
    register.add(Id.buttonAttributeTemplateAdd, 'Add', 'Button label for adding an attribute template');
    register.add(
      Id.buttonAttributeTemplateUpdate,
      'Update Template',
      'Button label for updating an attribute template'
    );
    register.add(
      Id.buttonAttributeTemplateDelete,
      'Delete Template',
      'Button label for deleting an attribute template'
    );
    register.add(Id.buttonAttributeTemplateReset, 'Reset Template', 'Button label for resetting an attribute template');
    register.add(Id.buttonAttributeTemplateView, 'View Differences', 'Button label for viewing an attribute template');
    register.add(Id.buttonAttributeTemplateHide, 'Hide Differences', 'Button label for hiding an attribute template');
    register.add(Id.buttonAttributeTemplateApply, 'Apply Values', 'Button label for applying an attribute template');
    register.add(Id.buttonAttributeTemplateShowValues, 'Show Values', 'Button label for showing template values');
    // Template message registrations
    register.add(
      Id.messageAttributeTemplateUpdated,
      'Template "{{templateName}}" for {{frameType}} has been updated successfully. Changes will be saved with the {{glossary "frame"}}',
      'Message shown when an attribute template has been successfully updated'
    );
    register.add(
      Id.messageAttributeTemplateDeleted,
      'Template "{{templateName}}" for {{frameType}} has been deleted',
      'Message shown when an attribute template has been deleted'
    );
    register.add(
      Id.attributeTemplateApplied,
      'Template "{{templateName}}" for {{frameType}} has been applied with {{attributeCount}} attribute changes',
      'Message shown when an attribute template has been applied to a frame'
    );

    // VRML viewer translations
    register.add(Id.vrmlViewerTitle, '3D Model Viewer', 'Default title for the VRML 3D model viewer');
    register.add(Id.vrmlViewerClose, 'Close', 'Close button caption for the VRML 3D model viewer');
    register.add(Id.vrmlViewerModels, 'Models', 'Label for the models list in the VRML viewer');
    register.add(
      Id.vrmlViewerNoModel,
      'No 3D model available for this frame.',
      'Message displayed when no 3D model is available'
    );
  }
}
